import { render } from "./Touch.vue?vue&type=template&id=d9bde9c0"
import script from "./Touch.vue?vue&type=script&lang=js"
export * from "./Touch.vue?vue&type=script&lang=js"

import "./Touch.vue?vue&type=style&index=0&id=d9bde9c0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__